export default "__VITE_ASSET__COGmytsu__"